import {VariantConfigT} from '@/lib/types/colors.types';

export const dangerConfig: VariantConfigT = {
  basic: {
    icon: 'danger',
    iconHover: 'white',
    iconActive: 'white',
    hover: 'danger',
    active: 'danger',
  },
  outline: {
    icon: 'danger',
    iconHover: 'white',
    iconActive: 'white',
    hover: 'white',
    active: 'white',
  },
  ghost: {
    icon: 'danger',
    iconHover: 'danger',
    iconActive: 'danger',
    hover: 'danger',
    active: 'danger',
  },
  gradient: {
    icon: 'white',
    iconHover: 'white',
    iconActive: 'white',
    hover: 'white',
    active: 'white',
  },
  solid: {
    icon: 'white',
    iconHover: 'white',
    iconActive: 'white',
    hover: 'white',
    active: 'white',
  },
};
